import TestApi from '../api/test';
import TestCategory from '../models/test/category';
import TestTest from '../models/test/test';
import TestResult from '../models/test/result';

const env = process.env;
const testApi = new TestApi(
  env.VUE_APP_CLINIC_API_TEST_URL,
  env.VUE_APP_CLINIC_API_TEST_TIMEOUT
);

const state = {
  categories: [],
  tests: [],
  results: {},
};

const getters = {
  getTestClientResults: state => clientId => {
    if (!state.results[clientId]) {
      return [];
    }

    return state.results[clientId];
  },
};

const mutations = {
  TEST_SET_CATEGORIES: (state, payload) => {
    const categories = [];

    for (const item of payload) {
      categories.push(new TestCategory(item));
    }

    state.categories = categories;
  },

  TEST_SET_TESTS: (state, payload) => {
    const tests = [];

    for (const item of payload) {
      tests.push(new TestTest(item));
    }

    state.tests = tests;
  },

  TEST_SET_RESULTS: (state, payload) => {
    const results = [];

    for (const item of payload.result) {
      results.push(new TestResult(item));
    }

    state.results[payload.clientId] = results;
    state.results = Object.assign({}, state.results);
  },
};

const actions = {
  TEST_LOAD_CATEGORIES: async (context) => {
    const data = await testApi.getCategories(context.rootState.token);

    context.commit('TEST_SET_CATEGORIES', data);
  },

  TEST_LOAD_TESTS: async (context) => {
    const data = await testApi.getTests(context.rootState.token);

    context.commit('TEST_SET_TESTS', data);
  },

  TEST_UPDATE_TEST: async (context, payload) => {
    const {id, data} = payload;

    await testApi.updateTest(context.rootState.token, id, data);

    await context.dispatch('TEST_LOAD_TESTS');
  },

  TEST_DELETE_TEST: async (context, payload) => {
    await testApi.deleteTest(context.rootState.token, payload);

    await context.dispatch('TEST_LOAD_TESTS');
  },

  TEST_CREATE_TEST: async (context, payload) => {
    const {data} = payload;

    await testApi.createTest(context.rootState.token, data);

    await context.dispatch('TEST_LOAD_TESTS');
  },

  TEST_LOAD_RESULTS: async (context, payload) => {
    const result = await testApi.getResults(context.rootState.token, payload);
    const data = {result, clientId: payload};

    context.commit('TEST_SET_RESULTS', data);
  },

  TEST_ADD_RESULT: async (context, payload) => {
    await testApi.addResult(context.rootState.token, payload);

    await context.dispatch('TEST_LOAD_RESULTS', payload.client);
  },

  TEST_UPDATE_RESULT: async (context, payload) => {
    const {id, data, client} = payload;

    await testApi.updateResult(context.rootState.token, id, data);

    await context.dispatch('TEST_LOAD_RESULTS', client);
  },

  TEST_DELETE_RESULT: async (context, payload) => {
    const {id, client} = payload;

    await testApi.deleteResult(context.rootState.token, id);

    await context.dispatch('TEST_LOAD_RESULTS', client);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
